import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import { PaperMaterial } from "../paper-material";

export const PaperGoodsReceiptItem = types
  .compose(
    Base,
    types.model({
      materialId: types.maybeNull(types.string),
      material: types.maybeNull(PaperMaterial),
      amount: types.maybeNull(types.number),
      wareHouse: types.maybeNull(types.string),
      brand: types.maybeNull(types.string),
      serialNumber: types.maybeNull(types.string),
      origin: types.maybeNull(types.string),
      supplier: types.maybeNull(types.string),
      document: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
      rollNumber: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IPaperGoodsReceiptItem
  extends Instance<typeof PaperGoodsReceiptItem> {}
export interface IPaperGoodsReceiptItemProperties
  extends SnapshotIn<typeof PaperGoodsReceiptItem> {}

export interface IAddPaperGoodsReceiptItem
  extends Omit<IPaperGoodsReceiptItemProperties, "material" | keyof IBase> {}

export interface IUpdatePaperGoodsReceiptItem
  extends Omit<IPaperGoodsReceiptItemProperties, "material"> {}
